import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

  defaultThresholds: any = {
    low: 10,
    medium: 20,
    high: 30
  };

  constructor(private http: HttpClient) { }

  patchWimdThresholdsSettings(settings): Observable<any> {
    let request= `my/settings`;
    return this.http.patch(request, settings);
  }
}
